// src/actions/recipes_actions.js
import axios from "axios";
import {
    FETCH_TOP_RECIPE_EVENT_COUNTS_LOADING,
    FETCH_TOP_RECIPE_EVENT_COUNTS_SUCCESS,
    FETCH_TOP_RECIPE_EVENT_COUNTS_FAIL,
    FETCH_SEARCH_RECIPES_LOADING,
    FETCH_SEARCH_RECIPES_SUCCESS,
    FETCH_SEARCH_RECIPES_FAIL,
    FETCH_LATEST_RECIPES_LOADING,
    FETCH_LATEST_RECIPES_SUCCESS,
    FETCH_LATEST_RECIPES_FAIL,
    FETCH_LATEST_PGRECIPES_LOADING,
    FETCH_LATEST_PGRECIPES_SUCCESS,
    FETCH_LATEST_PGRECIPES_FAIL,
    FETCH_SEARCH_ALLRECIPES_LOADING,
    FETCH_SEARCH_ALLRECIPES_SUCCESS,
    FETCH_SEARCH_ALLRECIPES_FAIL,
} from "./types";

export const fetchAllsearchRecipes = (
  type = "all",
  limit = 10,
  searchTerm = "",
  source = "mysql" // <— for now, keep MySQL-only; later switch to "both"
) => async (dispatch) => {
  dispatch({ type: FETCH_SEARCH_ALLRECIPES_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    // NEW merged route
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/recipes/search-merged`;

    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { type, limit, searchTerm, source },
    });

    if (response.data.success) {
      dispatch({
        type: FETCH_SEARCH_ALLRECIPES_SUCCESS,
        payload: response.data.data,
      });
    } else {
      dispatch({
        type: FETCH_SEARCH_ALLRECIPES_FAIL,
        payload: response.data.message,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_SEARCH_ALLRECIPES_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const fetchLatestRecipesPG = (type = 'all', limit = 50) => async dispatch => {
  dispatch({ type: FETCH_LATEST_PGRECIPES_LOADING });

  try {
    const token    = localStorage.getItem('jwtToken');
    const apiUrl   = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/recipes/latest-recipes-pg`;
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { type, limit },
    });

    if (response.data.success) {
      dispatch({
        type:    FETCH_LATEST_PGRECIPES_SUCCESS,
        payload: response.data.data,  // array of recipe objects
      });
    } else {
      dispatch({
        type:    FETCH_LATEST_PGRECIPES_FAIL,
        payload: response.data.message,
      });
    }
  } catch (err) {
    dispatch({
      type:    FETCH_LATEST_PGRECIPES_FAIL,
      payload: err.response?.data?.message || err.message,
    });
  }
};

export const fetchLatestRecipes = (
  type = 'all',
  limit = 50,
  source = 'mysql' // mysql | pg | both (merged endpoint)
) => async (dispatch) => {
  dispatch({ type: FETCH_LATEST_RECIPES_LOADING });

  try {
    const token  = localStorage.getItem('jwtToken');
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/recipes/latest-recipes-merged`;

    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { type, limit, source },
    });

    if (response.data.success) {
      dispatch({
        type: FETCH_LATEST_RECIPES_SUCCESS,
        payload: response.data.data, // array of recipe objects
      });
    } else {
      dispatch({
        type: FETCH_LATEST_RECIPES_FAIL,
        payload: response.data.message,
      });
    }
  } catch (err) {
    dispatch({
      type: FETCH_LATEST_RECIPES_FAIL,
      payload: err.response?.data?.message || err.message,
    });
  }
};

export const fetchsearchRecipes = (
  searchTerm
) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/recipes/all-recipes-data-search-v2`;

  dispatch({ type: FETCH_SEARCH_RECIPES_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        searchTerm
      },
    });
    const respData = response.data;
    if (respData.success) {
      dispatch({
        type: FETCH_SEARCH_RECIPES_SUCCESS,
        payload: {
          recipes: respData.data, // array of ranked recipe records
          // total: respData.totalRegisterUser, // use total if your API returns one (adjust if needed)
        },
      });
    } else {
      dispatch({
        type: FETCH_SEARCH_RECIPES_FAIL,
        payload: respData.message,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Unexpected error";
    dispatch({
      type: FETCH_SEARCH_RECIPES_FAIL,
      payload: errorMessage,
    });
  }
};

export const fetchTopRecipeEventCounts = (
  orderRank,
  datefilter,
  startTime,
  endTime,
  countType,
  limit,
  source = "mysql" // <— default to MySQL only
) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/recipes/recipes-info-ranked-v3-merged`;

  dispatch({ type: FETCH_TOP_RECIPE_EVENT_COUNTS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");

    const params = {
      orderRank,
      datefilter,
      countType,
      limit,
      source, // always mysql unless overridden
      ...(startTime ? { startTime } : {}),
      ...(endTime ? { endTime } : {}),
    };

    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });

    const respData = response.data;

    if (respData.success) {
      dispatch({
        type: FETCH_TOP_RECIPE_EVENT_COUNTS_SUCCESS,
        payload: {
          recipes: respData.data,
        },
      });
    } else {
      dispatch({
        type: FETCH_TOP_RECIPE_EVENT_COUNTS_FAIL,
        payload: respData.message,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_TOP_RECIPE_EVENT_COUNTS_FAIL,
      payload: error.response?.data?.message || error.message || "Unexpected error",
    });
  }
};
